import TreeMenu from '@/components/ui/tree-menu';
import { useCategories } from '@/framework/category';
import Skeleton from '@/components/Skeleton';
import { AnimatedCollapseContainer } from './Collapse';

export const TreeGroupMenu = ({
  id,
  groupSlug,
  selectedCategorySlug
}: {
  parentKeyId: string;
  id: string;
  groupId: number | string;
  groupSlug: string;
  selectedCategorySlug?: string;
}) => {
  const { categories, isLoading } = useCategories({
    type: groupSlug,
    with: 'children',
  });

  if (isLoading) {
    return <Skeleton.Square width="84%" height="20px" />;
  }

  return (
    <AnimatedCollapseContainer>
      <TreeMenu
        parentKeyId={`scroll-bar-menu-group-${id}`}
        items={categories || []}
        selectedCategorySlug={selectedCategorySlug}
      />
    </AnimatedCollapseContainer>
  );
};
